(function (window, document, undefined) {
  "use strict";

  let Vue = window.Vue || false,
    logger = {};

  try {
    logger = new window.RussMedia.Utils.Logger();
  } catch (e) {
    logger = { log: function () {} };
  }

  /**
   * Send tracking data to GA.
   *
   * @return {undefined}
   */
  const trackGA = (category, url) => {
    const eventCategory = category || "",
      eventLabel = url || "";

    if (dataLayer) {
      const eventData = {
        event: "genericEvent",
        eventCategory,
        eventAction: "click",
        eventLabel,
      };

      dataLayer.push(eventData);

      document.dispatchEvent(
        new CustomEvent("hansrmdtevent", { detail: eventData })
      );
    }
  };

  /**
   * Send tracking data to ÖWA.
   *
   * @return {undefined}
   */
  const trackOEWA = (type) => {
    if (typeof oewa_data === "undefined") {
      return;
    }

    const oldOEWA = oewa_data.cp,
      modOEWA = oewa_data.cp, //get it from referer page
      agency = modOEWA.substring(modOEWA.lastIndexOf("/") + 1),
      elements = modOEWA.split("/");

    if (modOEWA.includes("Homepage")) {
      elements[1] = "Nachrichten";
      elements[2] = "LokaleNachrichten";
    }

    let userAgent = navigator.userAgent;
    let device = "";

    if (/android/i.test(userAgent)) {
      device = "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      device = "iOS";
    }

    if (device === "Android" || device === "iOS") {
      //new OEWA tracking code
      oewa_data["cp"] =
        elements[0] +
        "/" +
        elements[1] +
        "/" +
        elements[2] +
        "/moewa" +
        type +
        "/" +
        agency;
    } else {
      //new OEWA tracking code
      oewa_data["cp"] =
        elements[0] +
        "/" +
        elements[1] +
        "/" +
        elements[2] +
        type +
        "/" +
        agency;
    }

    if (typeof window.IOMm !== "undefined") {
      window.IOMm("pageview", { cp: oewa_data["cp"] });
    }

    oewa_data["cp"] = oldOEWA; //set OEWA.cp to old value
  };

  /**
   * Grab the JSON that should be provided in the page and parse it.
   *
   * @return {object|boolean} The widget data object on success, false otherwise.
   */
  const parseWidgetData = (slider) => {
    const sliderDataNode = slider.querySelector(
      'script[type="application/json"]'
    );

    let sliderData = {};

    try {
      sliderData = JSON.parse(sliderDataNode.innerHTML) || {};
    } catch (ex) {
      logger.log("could not parse video slider data", ex);
      return false;
    }

    return sliderData;
  };

  const initSlider = (slider) => {
    slider.classList.remove("pre-init");
    let sliderData = parseWidgetData(slider);

    let item = {};
    try {
      item = sliderData.item;
    } catch (e) {
      logger.log(
        "vodl video slider sliderData: sliderData.items not found",
        sliderData
      );
    }

    let breakpoints = {};
    try {
      breakpoints = sliderData.breakpoints;
    } catch (e) {
      logger.log(
        "vodl video slider sliderData: sliderData.breakpoints not found",
        sliderData
      );
    }

    let linkPrefix = "";
    try {
      linkPrefix = sliderData.linkPrefix;
    } catch (e) {
      logger.log(
        "vodl video slider sliderData: sliderData.linkPrefix not found",
        sliderData
      );
    }

    const openInNewWindow = sliderData.openInNewWindow
      ? sliderData.openInNewWindow
      : false;

    const sliderWrapper = slider.querySelector(".vodl-video-slider__wrapper");
    const trackingCategory =
      linkPrefix && linkPrefix.includes("format")
        ? "video_format_slider"
        : "video_detail_slider";

    Vue.createApp({
      components: {
        CardSection: window["@russmedia-frontend/np-common"].CardSection,
      },
      setup() {
        /**
         * Track article click
         */
        function onItemClicked(e) {
          e = e || {};
          e.link = e.link || "";
          e.isLinkExternal = e.isLinkExternal || false;

          if (!e.link) return;

          trackOEWA(trackingCategory, e.link);
          trackGA(trackingCategory, e.link);

          if (e.isLinkExternal || openInNewWindow) {
            window.open(e.link, "_blank").focus();
            return;
          }

          window.location.href = e.link;
        }

        /**
         * action on button click
         */
        function onButtonClicked(e) {
          if (!e.buttonLink) return;

          trackGA(trackingCategory, e.buttonLink);

          if (openInNewWindow) {
            window.open(e.buttonLink, "_blank").focus();
            return;
          }

          window.location.href = e.buttonLink;
        }

        return {
          item,
          breakpoints,
          openInNewWindow,
          onItemClicked,
          onButtonClicked,
        };
      },
    }).mount(sliderWrapper);
  };

  /**
   * Initialize.
   * Check if Vue is available, get the slider data.
   *
   * @return {undefined}
   */
  const init = () => {
    const videoSliders = document.querySelectorAll(
      ".vodl-video-slider.pre-init"
    );

    if (videoSliders.length < 1) return;

    if (!Vue) {
      logger.log("video slider init: No Vue!");
      return;
    }

    videoSliders.forEach((videoSlider) => {
      initSlider(videoSlider);
    });
  };

  init();
  document.addEventListener("newPage", init);
})(window, document);
